import React from "react";
import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
// unused imports removed
import Header from "../../../components/Header";
import Swal from "sweetalert2";
import { generateAndExecuteMutation } from "../../../data/Axios/DynamicService";
import { setupManagementUrl } from "../../../config";
const base_url = setupManagementUrl.uri;
//const base_url = "https://localhost:7210/graphql/"
/**
 * IntervalForm
 *
 * This component is used to create or edit an interval. It renders a form with
 * an input for the interval and a submit button. The form is wrapped in a
 * Formik component which handles the form state and the validation of the
 * form fields.
 *
 * @param {Object} props - The props of the component.
 * @param {boolean} props.isEditing - Whether the form is being used to edit an
 * existing interval or to create a new one.
 * @param {Object} props.data - The data of the interval to be edited. This
 * prop is only used if `isEditing` is true.
 * @param {Function} props.onClose - A function that is called when the form is
 * submitted and the modal is closed.
 * @param {Function} props.refetchData - A function that is called when the form is
 * submitted and the data of the interval is updated.
 */

const DiscountTypeForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);

  const initialValues = {
    name: props.data ? props.data.name : "",
    description: props.data ? props.data.description : "",
  };

  const validationSchema = yup.object().shape({
    name: yup.string().required("Discount Type name is required"),
    description: yup.string().required("Discount Type description is required"),

  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { name, description } = values;
      const mutationData = {
        name,
        description,
        isActive: true,
      };

      if (props.isEditing) {
        mutationData.id = props.data.id;
        mutationData.updatedBy = userId;
        mutationData.createdBy = props.data.createdBy;
      } else {
        mutationData.createdBy = userId;
      }
      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateDiscountTypes" : "createDiscountTypes",
        mutationData,
        "discountTypes",
        base_url
      );
      if (response) {
        props.onClose();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Discount Type ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        }).then(() => {
          props.refetchData(); // Close the modal after the success message
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <Box m="20px" bgcolor="background.paper" p={3}>
      <Header
        title={props.isEditing ? "Edit Discount Type" : "Create Discount Type"}
        subtitle={
          props.isEditing
            ? "Edit an existing Discount Type"
            : "Create a new Discount Type"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Discount Type Name *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="name"
                error={touched.name && !!errors.name}
                helperText={touched.name && errors.name}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Description *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.description}
                name="description"
                error={touched.description && !!errors.description}
                helperText={touched.description && errors.description}
              />

              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default DiscountTypeForm;
